import React from 'react';
import { ClipPlayer } from './ClipPlayer';

const VERSION = '20261027e';

export const WorkflowSlide = ({ wf, sectionTitle, sectionNo, index, refId }) => (
  <section className="sc-slide sc-wf" data-testid={`showcase-workflow-${wf.id}`}>
    <div className="sc-text">
      <div className="sc-num">{String(sectionNo).padStart(2, '0')}.{index + 1} · {sectionTitle}</div>
      <h3 className="sc-title sc-wf-title" data-testid={`showcase-workflow-title-${wf.id}`}>{wf.title}</h3>
      <p className="sc-value">{wf.intro}</p>
      <ol className="sc-steps">
        {wf.steps.map((s, i) => (
          <li key={s}><span className="sc-step-no">{i + 1}</span><span>{s}</span></li>
        ))}
      </ol>
      {refId && <ClipPlayer refId={refId} />}
    </div>
    <div className="sc-shots">
      <figure className="sc-shot">
        <img src={`/showcase/wf/${wf.id}.png?v=${VERSION}`} alt={`${wf.title} screen`} data-testid={`showcase-wf-img-${wf.id}`} />
      </figure>
    </div>
  </section>
);
